// 관리자 콘솔 진입점.
// 사용자 앱과 코드 구조는 유사하지만 PWA/Capacitor 분기가 없는 웹 전용 환경이다.
// 신규 주문 소리 알람 + 사이드바 배지는 전역 NewOrdersProvider(src/features/orders)가 처리한다(셸 안쪽 마운트).

import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfirmProvider } from "@oo/ui";
import App from "./App.tsx";
// Pretendard 가변폰트(동적 서브셋) - 사용자 앱과 동일한 self-host 폰트로 브랜드 일관성 유지.
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 관리자 콘솔은 운영 데이터를 자주 갱신하므로 staleTime 을 짧게 잡는다.
      staleTime: 5_000,
      retry: 1,
    },
  },
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("root element not found");
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ConfirmProvider>
          <App />
        </ConfirmProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
